// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6e1c5c0b","732":"f9e55121","977":"656c069d"}[chunkId] + ".chunk.js";
};